package com.essntl.features.invoice.ui.addeditinvoice

import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import com.essntl.core.quickbooks.data.QuickbooksInvoice
import com.essntl.core.utils.viewmodel.State
import com.essntl.features.category.domain.model.CategoryModel
import com.essntl.features.invoice.domain.model.InvoiceModel
import com.essntl.features.itinerary.domain.model.ItineraryModel
import com.essntl.features.itinerary.domain.model.ItineraryServiceModel
import com.essntl.features.paymentparameter.domain.model.PaymentParameterModel
import com.essntl.features.proposal.domain.model.ProposalModel
import com.essntl.features.proposal.domain.model.ProposalServiceModel
import com.essntl.features.paymentlink.domain.model.PaymentLinkModel
import com.essntl.features.service.domain.model.extraservice.ExtraServiceModel

data class AddEditInvoiceState(
    val getInvoice: State<InvoiceModel> = State(),
    val getInvoiceProposalServices: State<List<ProposalServiceModel>> = State(),
    val getInvoiceItineraryServices: State<List<ItineraryServiceModel>> = State(),

    val getProposal: State<ProposalModel> = State(),
    val getProposalServices: State<List<ProposalServiceModel>> = State(),

    val getItinerary: State<ItineraryModel> = State(),
    val getItineraryServices: State<List<ItineraryServiceModel>> = State(),

    val extraServiceList: State<List<ExtraServiceModel>> = State(),

    val addEditInvoice: State<InvoiceModel> = State(),

    val checkedServiceIds: Set<String> = emptySet(),

    val clientInvoice: Boolean = false,
    val notesToCustomer: MutableState<String> = mutableStateOf("Thank you for your business!\nPlease remit your payment to\n\nBE ESSENTIAL TRAVEL CONCIERGE INC\n8202 NW 79th Ave, Tamarac, FL 33321\n\nBank : CHASE\nRouting : 267084131 (ACH & Direct Deposit)\nAccount : 962810229\nWire Transfers ABA# 021000021\n\nCONDITIONS: \nClient agrees to accept all bank charges as applicable\nCREDIT CARDS: \nPayment by credit cards will incur a surcharge of: 3.5% for Amex, Visa or MC 3.5%. The client’s credit card will be charged in the local currency and will be exchanged by the client’s bank at the exchange rate applicable on the day the bank processes the charge. For this reason, there may be a variation in the price quoted and the actual rate processed on the client’s credit card.\n\nBy paying this invoice you agree to our Terms and Conditions previously mentioned on the proposal."),

    val getAllCategory: State<List<CategoryModel>> = State(),
    val getPaymentParameters: State<List<PaymentParameterModel>> = State(),

    val dueDate: String = "",
    val openQuickbooksRefreshWebpage: Boolean = false,

    // QuickbooksInvoice
    val getQuickbooksInvoice: State<QuickbooksInvoice> = State(),
    val sparseUpdateInvoice: State<QuickbooksInvoice> = State(),

    // Payment links
    val getPaymentLinks: State<List<PaymentLinkModel>> = State(),
    val addPaymentLink: State<Unit> = State(),

    // Set of link id
    val deactivatePaymentLinkLoadingSet: Set<String> = emptySet(),

    // String: file path
    val loadingDownloadQuickbookIds: Set<String> = emptySet(),
    val downloadQuickbooksInvoice: State<Pair<String, QuickbooksInvoice>> = State(),
) {
    val isLoading
        get() = getInvoice.isLoading ||
            getQuickbooksInvoice.isLoading ||
            getProposal.isLoading ||
            getItinerary.isLoading ||
            getPaymentLinks.isLoading ||
            getPaymentParameters.isLoading ||
            getAllCategory.isLoading ||
            getProposalServices.isLoading ||
            getItineraryServices.isLoading ||
            extraServiceList.isLoading ||
            getInvoiceProposalServices.isLoading ||
            getInvoiceItineraryServices.isLoading

    val isFailure
        get() = getInvoice.isFailure ||
            getQuickbooksInvoice.isFailure ||
            getProposal.isFailure ||
            getItinerary.isFailure ||
            getPaymentLinks.isFailure ||
            getPaymentParameters.isFailure ||
            getAllCategory.isFailure ||
            getProposalServices.isFailure ||
            getItineraryServices.isFailure ||
            extraServiceList.isFailure ||
            getInvoiceProposalServices.isFailure ||
            getInvoiceItineraryServices.isFailure

    val getAllProposalServices: List<ProposalServiceModel>
        get() = (getProposalServices.data.orEmpty() +
            getInvoiceProposalServices.data.orEmpty())
            .distinctBy { it.id }

    val getAllItineraryServices: List<ItineraryServiceModel>
        get() = (getItineraryServices.data.orEmpty() +
            getInvoiceItineraryServices.data.orEmpty())
            .distinctBy { it.id }
}
